export class ApiError extends Error {
  constructor(public status: number, message: string, public details?: unknown) {
    super(message);
  }
}

async function handle<T>(res: Response): Promise<T> {
  if (res.status === 204) return undefined as T;
  const text = await res.text();
  let data: unknown = null;
  try { data = text ? JSON.parse(text) : null; } catch { data = text; }
  if (!res.ok) {
    const msg = (data && typeof data === "object" && "error" in data ? (data as { error: string }).error : null) ?? `${res.status} ${res.statusText}`;
    throw new ApiError(res.status, msg, data && typeof data === "object" && "details" in data ? (data as { details: unknown }).details : undefined);
  }
  return data as T;
}

const base = "/api";

export const api = {
  get: <T>(path: string) => fetch(base + path, { credentials: "include" }).then((r) => handle<T>(r)),
  post: <T>(path: string, body?: unknown) =>
    fetch(base + path, { method: "POST", credentials: "include", headers: { "Content-Type": "application/json" }, body: body === undefined ? undefined : JSON.stringify(body) }).then((r) => handle<T>(r)),
  patch: <T>(path: string, body: unknown) =>
    fetch(base + path, { method: "PATCH", credentials: "include", headers: { "Content-Type": "application/json" }, body: JSON.stringify(body) }).then((r) => handle<T>(r)),
  put: <T>(path: string, body: unknown) =>
    fetch(base + path, { method: "PUT", credentials: "include", headers: { "Content-Type": "application/json" }, body: JSON.stringify(body) }).then((r) => handle<T>(r)),
  del: <T>(path: string) => fetch(base + path, { method: "DELETE", credentials: "include" }).then((r) => handle<T>(r)),
  upload: <T>(path: string, form: FormData) => fetch(base + path, { method: "POST", credentials: "include", body: form }).then((r) => handle<T>(r)),
};
